import { TableNoDataOverlayTemplate } from "themes/common/components";

function TableNoDataOverlay() {
    return <TableNoDataOverlayTemplate />;
}

export default TableNoDataOverlay;
